import { render, staticRenderFns } from "./exportCountryYearReportCopy1.vue?vue&type=template&id=2d2b90fe&scoped=true"
import script from "./exportCountryYearReportCopy1.vue?vue&type=script&lang=js"
export * from "./exportCountryYearReportCopy1.vue?vue&type=script&lang=js"
import style0 from "./exportCountryYearReportCopy1.vue?vue&type=style&index=0&id=2d2b90fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b90fe",
  null
  
)

export default component.exports